import request from '@/api/request.js'

// 上传
export function UploadFile(data) {
    return request({
        url: '/api/upload/uploadfile',
        method: 'post',
        data: data
    })
}